import { Tooltip } from "@mui/material";
import { Body } from "@vds/typography";

const UsersEllipse=({group,handleToggle,all})=>{

    const displayNames = all? group?.allUsers?.map(user => user?.name).join(", ")
    : group?.displayedUsers;

    return(
            <span>
                {displayNames}
                {group?.hasMoreUsers && (
                    <Tooltip
                    title={
                        <Body
                        size="medium"
                        color="#FFFFFF"
                        >
                        {group?.allUsers?.map(user => `${user?.name}`).join(", ")}
                        </Body>
                    }
                    arrow
                    placement="top"
                    >
                        <span
                        style={{
                            cursor:"pointer",
                            marginLeft:'5px',
                            color:"grey",
                        }}>
                            ...
                        </span>
                    </Tooltip>
                )}
                </span>
    )}
export default UsersEllipse;